/* One state controller for the product page and quick view. No catalogue writes. */
(() => {
  'use strict';
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const words = document.documentElement.lang === 'en'
    ? { available: 'Available', sold: 'Sold out', add: 'Add to cart', image: 'Image' }
    : { available: 'Verfügbar', sold: 'Ausverkauft', add: 'In den Warenkorb', image: 'Bild' };
  const dialog = $('[data-image-lightbox]');
  let zoomReturn = null;
  const zoom = (img, trigger) => {
    if (!img || !dialog) return;
    const target = $('img', dialog);
    target.src = img.src; // largest source, not the responsive thumbnail
    target.alt = img.alt;
    zoomReturn = trigger;
    dialog.showModal();
  };
  $('[data-image-lightbox-close]')?.addEventListener('click', () => dialog.close());
  dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog?.addEventListener('close', () => zoomReturn?.focus());

  function init(root) {
    if (root.dataset.productReady) return;
    const source = $('[data-variant-data]', root);
    if (!source) return;
    let data;
    try { data = JSON.parse(source.textContent); } catch (_) { return; }
    root.dataset.productReady = 'true';
    const gallery = $('[data-gallery]', root);
    const stage = $('[data-gallery-stage]', root);
    const slides = $$('[data-media-id]', root);
    const thumbs = $$('[data-gallery-thumb]', root);
    const select = $('[data-variant-select]', root);
    let index = 0;
    let current = data.variants.find(v => v.id === data.selected) || data.variants[0];

    const show = (next) => {
      if (!slides.length) return;
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
      const count = $('[data-gallery-count]', root);
      if (count) count.textContent = `${words.image} ${index + 1} / ${slides.length}`;
      const selected = thumbs[index];
      const tray = selected?.parentElement;
      if (tray) tray.scrollTo({ left: selected.offsetLeft - tray.offsetLeft - tray.clientWidth / 2 + selected.clientWidth / 2, behavior: 'auto' });
    };
    const apply = (variant, updateURL = false) => {
      if (!variant) return;
      current = variant;
      root.dataset.variantAvailable = String(variant.available);
      if (select) select.value = String(variant.id);
      $$('[name="id"]', root).forEach(input => { input.value = String(variant.id); });
      $$('[data-variant-price]', root).forEach(el => { el.textContent = variant.price; });
      $$('[data-variant-compare]', root).forEach(el => { el.hidden = !variant.compare; el.textContent = variant.compare || ''; });
      $$('[data-variant-sku]', root).forEach(el => { el.textContent = variant.sku || ''; });
      $$('[data-variant-sku-row]', root).forEach(el => { el.hidden = !variant.sku; });
      const specs = $('[data-product-specifications]', root);
      if (specs) specs.hidden = !$('.product-verified', specs) && !$$('.spec-table > div', specs).some(row => !row.hidden);
      $$('[data-variant-stock]', root).forEach(el => { el.textContent = variant.available ? words.available : words.sold; });
      $$('[name="add"],[data-mobile-submit]', root).forEach(el => { el.disabled = !variant.available; el.textContent = variant.available ? words.add : words.sold; });
      const detail = $('[data-product-detail]', root);
      if (detail) {
        const url = new URL(data.url, location.origin);
        url.searchParams.set('variant', variant.id);
        detail.href = url.href;
      }
      const media = variant.media || data.fallbackMedia;
      const next = slides.findIndex(slide => slide.dataset.mediaId === String(media));
      show(next < 0 ? 0 : next);
      if (root.hasAttribute('data-product-root')) {
        $$('[data-mobile-buy] span').forEach(el => { el.textContent = variant.price; });
        $$('[data-mobile-submit]').forEach(el => { el.disabled = !variant.available; el.textContent = variant.available ? words.add : words.sold; });
        if (updateURL) {
          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState(history.state, '', url);
        }
      }
    };

    const pick = (next) => {
      if (!slides.length) return;
      const bounded = (next + slides.length) % slides.length;
      const media = slides[bounded].dataset.mediaId;
      // Only unique, explicitly assigned variant images may change a purchase option.
      // Shared/detail images never change colour or size. Shared images retain selection.
      const related = data.variants.filter(v => String(v.media) === media);
      if (related.length === 1 && related[0].id !== current?.id) apply(related[0], true);
      show(bounded);
    };
    select?.addEventListener('change', () => apply(data.variants.find(v => String(v.id) === select.value), true));
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => pick(i)));
    $('[data-gallery-prev]', root)?.addEventListener('click', () => pick(index - 1));
    $('[data-gallery-next]', root)?.addEventListener('click', () => pick(index + 1));
    stage?.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      pick(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
    });
    let start;
    stage?.addEventListener('touchstart', event => { const p = event.touches[0]; start = { x: p.clientX, y: p.clientY }; }, { passive: true });
    stage?.addEventListener('touchend', event => {
      if (!start) return;
      const p = event.changedTouches[0], dx = p.clientX - start.x, dy = p.clientY - start.y;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) pick(index + (dx < 0 ? 1 : -1));
      start = null;
    }, { passive: true });
    $$('[data-gallery-zoom]', root).forEach(button => button.addEventListener('click', () => zoom($('img', button.parentElement), button)));
    $$('[data-gallery-controls],[data-gallery-thumbs]', root).forEach(el => { el.hidden = false; });
    gallery?.classList.add('is-ready');
    apply(current);
  }
  $$('[data-product-state]').forEach(init);
  document.addEventListener('azela:quick-view', event => $$('[data-product-state]', event.detail).forEach(init));
  document.addEventListener('shopify:section:load', event => $$('[data-product-state]', event.target).forEach(init));
})();

/* Capacity chips on a collection grid: a display filter over the products that are already
   loaded, never a catalogue write. snippets/capacity-facet.liquid renders the row only when
   a product carries a PUBLISHED capacity (azela_v2.capacity_l metafield or a kap-<number>
   tag); on top of that this controller removes the row again when no loaded product lands in
   one of the published bands, so an unusable filter can never be shown.

   The strict title rule lives here and only here: \b(\d{1,2})\s?L\b. "60L" and "40 L" are
   volumes, "500ml", "500 ml" and model codes such as "M258E01" are not. A volume read from a
   title is a display/filtering fallback and is disclosed as such in the UI, never presented
   as a specification. Published data always wins over it. */
(() => {
  'use strict';
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const VOLUME = /\b(\d{1,2})\s?L\b/;
  const parseTitle = (text) => {
    const match = VOLUME.exec(text || '');
    return match ? Number(match[1]) : 0;
  };
  // Band bounds come from the markup ("5-18"), so the published bands stay in one place.
  const bandOf = (value, band) => {
    const [min, max] = String(band).split('-').map(Number);
    return Number.isFinite(min) && Number.isFinite(max) && value >= min && value <= max;
  };
  const publishedOf = (card) => Number(card.dataset.capacity || 0);
  const capacityOf = (card) => publishedOf(card) || parseTitle(card.dataset.productTitle || '');
  // A facet only ever filters its own collection grid; other sections stay untouched.
  const cardsOf = (facet) => {
    const root = facet.closest('[data-collection-root]');
    return root ? $$('[data-product-card]', root) : [];
  };

  function show(facet, band) {
    const cards = cardsOf(facet);
    let shown = 0;
    let fromTitle = 0;
    cards.forEach((card) => {
      const value = capacityOf(card);
      const match = band === 'all' || (value > 0 && bandOf(value, band));
      card.hidden = !match;
      if (!match) return;
      shown += 1;
      if (!publishedOf(card)) fromTitle += 1;
    });
    $$('[data-capacity-chip]', facet).forEach((chip) => chip.setAttribute('aria-pressed', String(chip.dataset.capacityChip === band)));
    const status = $('[data-capacity-status]', facet);
    if (status) {
      status.textContent = (status.dataset.capacityStatusTemplate || '')
        .replace('[[count]]', shown)
        .replace('[[loaded]]', cards.length);
    }
    const source = $('[data-capacity-source]', facet);
    if (source) source.hidden = fromTitle === 0;
  }

  function mount(scope = document) {
    $$('[data-capacity-facet]', scope).forEach((facet) => {
      const chips = $$('[data-capacity-chip]', facet);
      const bands = chips.filter((chip) => chip.dataset.capacityChip !== 'all');
      const cards = cardsOf(facet);
      const counts = new Map(bands.map((chip) => [chip.dataset.capacityChip, 0]));
      cards.forEach((card) => {
        const value = capacityOf(card);
        if (value <= 0) return;
        bands.forEach((chip) => {
          const band = chip.dataset.capacityChip;
          if (bandOf(value, band)) counts.set(band, counts.get(band) + 1);
        });
      });
      if ([...counts.values()].every((count) => count === 0)) {
        // Nothing to filter: the row is dropped instead of shipped as an empty shell.
        facet.remove();
        return;
      }
      bands.forEach((chip) => {
        const count = counts.get(chip.dataset.capacityChip);
        chip.disabled = count === 0;
        const label = $('[data-capacity-count]', chip);
        if (label) label.textContent = `(${count})`;
      });
      const all = chips.find((chip) => chip.dataset.capacityChip === 'all');
      const allLabel = all ? $('[data-capacity-count]', all) : null;
      if (allLabel) allLabel.textContent = `(${cards.length})`;
      facet.hidden = false;
      show(facet, 'all');
    });
  }

  document.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-capacity-chip]');
    if (!chip || chip.disabled) return;
    const facet = chip.closest('[data-capacity-facet]');
    if (facet) show(facet, chip.dataset.capacityChip);
  });
  document.addEventListener('azela:collection', (event) => mount(event.detail || document));
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  mount();
  // Shared with any future consumer of the same rule.
  window.AzelaCapacity = { parseTitle, bandOf };
})();
